"use client";

import { PromptHistoryDialog } from "@shared/components/PromptHistoryDialog";
import { useTranslations } from "next-intl";
import { useEffect, useState } from "react";
import { useAiDescribeImage } from "../hooks/use-ai-describe-image";
import { FaqSection } from "./FaqSection";
import { ImageDescriptionGenerator } from "./ImageDescriptionGenerator";
import { WhyUseSection } from "./WhyUseSection";

export function AiDescribeImageClient() {
	const t = useTranslations("aiDescribeImage.client");
	const [isHistoryOpen, setIsHistoryOpen] = useState(false);
	const { descriptionHistory, setDescriptionHistory } = useAiDescribeImage();

	// Listen for opening history dialog event
	useEffect(() => {
		const handleOpenHistory = () => {
			setIsHistoryOpen(true);
		};

		window.addEventListener("openPromptHistory", handleOpenHistory);

		return () => {
			window.removeEventListener("openPromptHistory", handleOpenHistory);
		};
	}, []);

	return (
		<div className="space-y-6">
			<ImageDescriptionGenerator />

			<PromptHistoryDialog
				open={isHistoryOpen}
				onOpenChange={setIsHistoryOpen}
			/>

			<div className="mt-16">
				<WhyUseSection />
			</div>

			<div className="mt-16">
				<FaqSection />
			</div>
		</div>
	);
}
